import { ScaleTime } from 'd3-scale';
import { createContext } from 'react';

import { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

export interface UpdateSelectionStateProps {
  selection: [RelativeAbsolutePosition, RelativeAbsolutePosition];
  chartId: string;
  scale: ScaleTime<number, number>;
}

export interface SynchronizedSelectionContextProps {
  selectedChartId?: string;
  startX?: number;
  endX?: number;
  updateSelectionState?: (props?: UpdateSelectionStateProps) => void;
  resetSelectionState?: () => void;
  disabled?: boolean;
}

export const SynchronizedSelectionContext =
  createContext<SynchronizedSelectionContextProps>({});
